module.exports = __webpack_public_path__ + "static/media/menu-1.75529b26.png";